import { CircleLoader } from '@echodex/uikit'
import EchodexTable from 'components/EchodexTable/EchodexTable'
import useAccountActiveChain from 'hooks/useAccountActiveChain'
import { MainApiRoute, useMainApi } from 'hooks/useMainApi'
import { useEffect, useState } from 'react'

interface Props {
    yourPoint?: number
}

type dataLeaderBoard = {
    address: string
    point: string
}

const LeaderBoardTable = ({ yourPoint }: Props) => {
    const { account } = useAccountActiveChain()
    const [dataLeaderBoardTable, setDataLeaderBoardTable] = useState<dataLeaderBoard[]>()

    const leaderBoardInfoUser = useMainApi(MainApiRoute.GET_LEADER_BOARD_USER)
    useEffect(() => {
        if (!leaderBoardInfoUser) return
        setDataLeaderBoardTable(leaderBoardInfoUser)
    }, [leaderBoardInfoUser])
    if (!dataLeaderBoardTable)
        return (
            <div className="flex-center">
                <CircleLoader size="30px" />
            </div>
        )
    const matchedIndex =
        dataLeaderBoardTable && dataLeaderBoardTable.findIndex((item) => item.address === account?.toLowerCase())
    const checkIndex =
        dataLeaderBoardTable &&
        dataLeaderBoardTable.map((item, index) => (index === matchedIndex ? <div>{index + 1}</div> : null))

    const result = matchedIndex >= 0 ? checkIndex : <div>Unranked</div>
    return (
        <div className="max-h-[calc(100%-72px)] overflow-hidden overflow-y-auto ">
            <EchodexTable thead={THEAD} sticky>
                {!!account && (
                    <tr className="sticky top-[40px] bg-backgroundAlt2 border-t  ">
                        <td>
                            <div className="py-1 pl-4 text-pri">{result}</div>
                        </td>
                        <td>
                            <div className="text-pri">{`${account?.substring(0, 6)}...${account?.substring(
                                account.length - 4,
                            )}`}</div>
                        </td>
                        <td>
                            <div className="text-pri">{Number(yourPoint) ? Number(yourPoint).toFixed(2) : 0}</div>
                        </td>
                    </tr>
                )}
                {dataLeaderBoardTable &&
                    dataLeaderBoardTable.length > 0 &&
                    dataLeaderBoardTable?.map((item, i) => {
                        return (
                            <tr className=" even:bg-gray odd:bg-backgroundAlt2" key={item.address}>
                                <td>
                                    <div className="py-1 pl-4">{i + 1}</div>
                                </td>
                                <td>
                                    <div>{`${item.address.substring(0, 6)}...${item.address.substring(
                                        item.address.length - 4,
                                    )}`}</div>
                                </td>
                                <td>
                                    <div className="">{Number(item.point).toFixed(2)}</div>
                                </td>
                            </tr>
                        )
                    })}
            </EchodexTable>
        </div>
    )
}

type thead = {
    name: string
    width?: string
}
const THEAD: thead[] = [
    {
        name: 'Top',
    },
    {
        name: 'User',
    },
    {
        name: 'Total Point',
    },
]
export default LeaderBoardTable
